import React , { Component }  from 'react';
import { Button, Snackbar } from '@material-ui/core';
import TowInvoiceForm from './InvoiceForm';
import ShopInvoiceForm from './ShopInvoiceForm';
import invoiceService from '../../services/WebInvoiceService';
import { InvoiceType } from 'common/constants';
import LoadInvoiceForm from './LoadInvoiceForm';

const styles = {
    btn: {
        margin: '0.25rem 0.25rem 2rem 1rem'
    }
}

export default class EditInvoice extends Component {

    constructor(props) {
        super(props);
        this.initialInvoice = {}
            
        this.state = {
            invoice: null,
            changed: false,    
            status: {
                open: false,
                variant: 'success',
                message: "Invoice was updated successfully."
            }
        }
    }

    componentDidMount() {             
        let invoiceId  = this.props.match.params.invoiceId;
        let invoiceType = this.props.invoiceType;

        if(!isNaN(invoiceId)) {            
            invoiceService.getInvoice(invoiceId, invoiceType, (data) => {   
            this.initialInvoice = {
                ...data
            };
            this.setState({invoice : data});
          });
        }
    }

    handleChange = (event) => {      
        let previousInvoice = Object.assign({}, this.state.invoice);    //creating copy of object
        previousInvoice[event.target.id] = event.target.value;

        this.setState({
            invoice : previousInvoice
        }, () => {
            const changed = JSON.stringify(this.state.invoice) !== JSON.stringify(this.initialInvoice)
            this.setState({changed})            
        });
    };

    handleSaveClick = () => {        
        let invoiceId  = this.props.match.params.invoiceId;
        let invoiceType = this.props.invoiceType;   
        invoiceService.updateInvoice(invoiceId, invoiceType, this.state.invoice, (results) => {
            if (results && results.success) {
                this.setState({
                    changed: false,
                    status : {
                        open : true,                    
                        variant:'success',
                        message:'Invoice was updated successfully.'
                    }
                }, () => {
                    this.initialInvoice = {
                        ...this.state.invoice
                    };    
                });
            } else {
                this.setState({
                    status:  {
                        open : true,   
                        variant : '',
                        message : 'Failure to save invoice.'
                    }                    
                })
            }
        });
    }

    onPreviewClicked() {
        const invoiceId  = this.props.match.params.invoiceId;
        const customerId = this.props.match.params.customerId;     
        let invoicePart = InvoiceType.getInvoicePart(this.props.invoiceType)
        this.props.history.push({pathname:`/customer/${customerId}/${invoicePart}/${invoiceId}`});
    }

    getFormForType(invoiceType) {
        if(invoiceType === InvoiceType.LOAD) {
            return LoadInvoiceForm
        } else if(invoiceType === InvoiceType.SHOP) {
            return ShopInvoiceForm
        } else {
            return TowInvoiceForm
        }
    }

    render() {        
        let InvoiceForm = this.getFormForType(this.props.invoiceType)

        if (this.state.invoice) {
            const { invoice, status } = this.state;
            let invoiceId = InvoiceType.getNumberForInvoice(this.props.invoiceType,invoice)
            return (
                <div className="edit-invoice">
                    <InvoiceForm
                        {...invoice}
                        invoiceId={invoiceId}
                        handleChange={(event) => this.handleChange(event)} />
                    <div className="toolbar">
                        <Button
                            className='invoice-button view'
                            variant="outlined"
                            style={styles.btn}
                            color="primary"
                            onClick={() => this.onPreviewClicked()}>View Invoice
                        </Button>
                    
                        <Button
                            disabled={!this.state.changed}
                            className='invoice-button save'
                            variant='contained'
                            color='primary'
                            style={styles.btn}
                            onClick={() => this.handleSaveClick()}>Save Changes</Button>
                        <Snackbar
                            open={status.open}
                            message={status.message}
                            variant={status.variant}
                            autoHideDuration={3000}
                            anchorOrigin={{ vertical: 'top', horizontal: 'center',}}
                            onClose={() => this.setState({ status: { open: false } })}
                        />
                    </div>
                </div>
            );
        }
        return null;
    }
}
